/**
 * Whitelist Lucide icons autorisées dans les prototypes.
 * Doit rester en miroir de backend/prototype.py ALLOWED_TAB_ICONS.
 */
import {
  Home, Sparkles, Heart, Activity, Calendar, MessageCircle, BookOpen, Users,
  Settings, Music, MapPin, Video, Camera, Bell, Star, Trophy, Target, Compass,
  Search, Plus, User, Play, Shield, Brain,
} from 'lucide-react';

const ICONS = {
  home: Home,
  sparkles: Sparkles,
  heart: Heart,
  activity: Activity,
  calendar: Calendar,
  'message-circle': MessageCircle,
  'book-open': BookOpen,
  users: Users,
  settings: Settings,
  music: Music,
  'map-pin': MapPin,
  video: Video,
  camera: Camera,
  bell: Bell,
  star: Star,
  trophy: Trophy,
  target: Target,
  compass: Compass,
  search: Search,
  plus: Plus,
  user: User,
  play: Play,
  shield: Shield,
  brain: Brain,
};

export function getPrototypeIcon(name) {
  return ICONS[name] || Sparkles;
}
